module.exports = __webpack_public_path__ + "img/SWP_Shield_03 (1).9dcf9856.png";